import { get } from "lodash";
import moment from "moment";
import format from "string-template";
import { DATE_FORMAT } from "utils/constants";
import buildCardBlockHtml from "./buildCardBlockHtml";

const toDisplayValue = (value) => (value == null ? "" : value);

const buildEditorBlocks = ({
  emailContent,
  mailTranslations,
  project,
  costs,
  user,
  phoneNumber,
  email,
  address,
  addLinks,
}) => {
  const endOfValidityDate =
    moment().format("MM") === "12"
      ? moment().endOf("M").format(DATE_FORMAT)
      : moment().add(30, "d").format(DATE_FORMAT);

  const upsells = get(project, "fields.upsells", {});
  const allCombinations = get(project, "fields.combinations", []);
  const currentDevisKeys = get(
    project,
    "fields.currentDevisCombinationKeys",
    [],
  );
  const combinations =
    Array.isArray(currentDevisKeys) && currentDevisKeys.length > 0
      ? allCombinations.filter((combination) =>
          currentDevisKeys.includes(
            `${combination.baseInsurancePlanId}|${
              combination.complementaryInsurancePlanId || "none"
            }`,
          ),
        )
      : allCombinations;

  return {
    blocks: [
      {
        type: "paragraph",
        style: { fontSize: 20 },
        data: {
          text: format(get(emailContent, "HEADER", ""), {
            civility: toDisplayValue(
              get(
                emailContent,
                `CIVILITY_${get(project, "contact.user.gender", "")}`,
                "",
              ),
            ),
            lastName: toDisplayValue(get(project, "contact.user.lastname", "")),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: toDisplayValue(get(emailContent, "P1")),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(toDisplayValue(get(emailContent, "P2", "")), {
            currentDate: moment().format(DATE_FORMAT),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: toDisplayValue(get(emailContent, "P3")),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(toDisplayValue(get(emailContent, "P4", "")), {
            endOfValidityDate,
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        id: "cardBlock",
        type: "readonly",
        data: {
          text: buildCardBlockHtml({
            costs,
            upsells,
            combinations,
            addLinks,
            buttonLabel: toDisplayValue(
              get(emailContent, "SUBSCRIPTION_BUTTON"),
            ),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        type: "paragraph",
        data: {
          text: toDisplayValue(get(emailContent, "P5")),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(toDisplayValue(get(emailContent, "P6", "")), {
            phoneNumber: toDisplayValue(phoneNumber),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        type: "paragraph",
        data: {
          text: toDisplayValue(get(emailContent, "SINCERLY")),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "---",
        },
      },
      {
        type: "paragraph",
        data: {
          text: toDisplayValue(get(emailContent, "YOUR_ADVISOR")),
        },
      },
      {
        type: "paragraph",
        data: {
          text: [
            toDisplayValue(get(user, "firstname")),
            toDisplayValue(get(user, "lastname")),
          ]
            .filter(Boolean)
            .join(" "),
        },
      },
      {
        type: "paragraph",
        data: {
          text: `${toDisplayValue(mailTranslations.TEL)}: ${toDisplayValue(phoneNumber)}`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `${toDisplayValue(mailTranslations.EMAIL)}: ${toDisplayValue(email)}`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `${toDisplayValue(mailTranslations.ADDRESS)}: ${toDisplayValue(address)}`,
        },
      },
    ].filter((_) => get(_, "data.text") !== undefined),
  };
};

export default buildEditorBlocks;
